import styled from 'styled-components';

export const DesktopNotAllowedContainer = styled.div`
    max-width: 932px;
    width: 100%;
    margin: 52px auto 0 auto;

    .not-allowed-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        background-color: ${(props) => props.theme.palette.secondaryA10};
        padding: 64px;
        width: calc(100% - 32px);
        margin: 32px 16px 0 16px;

        .title {
            text-align: center;
        }

        .sub-title {
            margin-top: 32px;
            text-align: center;
        }

        .qr-container {
            padding: 30px;
            background-color: ${(props) => props.theme.palette.primaryA7};
            border-radius: 20px;
            margin-top: 20px;
        }

        .link-field {
            margin-top: 32px;
            max-width: 261px;
        }
    }
`;
